import { render, staticRenderFns } from "./RecordingDrawer.vue?vue&type=template&id=815f971e&scoped=true"
import script from "./RecordingDrawer.vue?vue&type=script&lang=ts"
export * from "./RecordingDrawer.vue?vue&type=script&lang=ts"
import style0 from "./RecordingDrawer.vue?vue&type=style&index=0&id=815f971e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815f971e",
  null
  
)

export default component.exports